import { render } from "./MaterialEditor.vue?vue&type=template&id=f906f902"
import script from "./MaterialEditor.vue?vue&type=script&lang=js"
export * from "./MaterialEditor.vue?vue&type=script&lang=js"

import "./MaterialEditor.vue?vue&type=style&index=0&id=f906f902&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__